const TicketsMaps = {}

/**
 * @abstract Key: activeType
 */
TicketsMaps.PacketDescMap = {
  'NEW_PERSON': '天美贷新用户专享活动',
  'PAY_IF_REFUSE_NEW': '天美贷拒就赔活动',
  'REDUCTION_INTEREST': '天美贷免息红包活动',
  'PERSON_REPEAT_LOAN': '天美贷新春赠礼活动',
  'DRAINAGE': '天美贷引流活动',
  'XIAOMEI_VIP': '小美VIP会员'
}
/**
 * @abstract Key: CouponType
 */
TicketsMaps.PacketTypeNameStrategies = {
  'COUPON': function (activeType) {
    if (['REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN'].includes(activeType)) { return '免息红包' }
  },
  'CASH': function () {
    return '现金红包'
  },
  'REFUSE_PAY_PASSIVE': function () {
    return '现金红包'
  },
  'LIMIT': function () {
    return '提额券'
  },
  'RIGHTS_INTERESTS': function (activeType, memberGoodsGroupCd, supportMemberGoodsName) {
    return (memberGoodsGroupCd === 'SVIP' || supportMemberGoodsName) ? '优惠券' : 'VIP优惠券'
  }
}

TicketsMaps.ButtonTitleMap = {
  'LIMIT': '使用优惠券',
  'RIGHTS_INTERESTS': '使用优惠券',
  'SVIP_RIGHTS_INTERESTS': '使用优惠券',
  'OTHER': function (status) {
    if (['PRE_PROVIDE', 'RECEIVED'].includes(status)) {
      return '提现红包'
    } else if (['USING'].includes(status)) {
      return '红包发放受理中'
    } else if (['USED'].includes(status)) {
      return '红包已使用'
    }
  },
  'DEFAULT': '提现红包'
}

TicketsMaps.DialogButtonTitleStrategy = (item) => {
  const { useAction, activeType, couponChannel, couponType } = item
  const map = {
    'ACCEPT': '开心收下',
    'CREDIT': '去授信',
    'INFO': '去授信',
    'OCR': '去授信',
    'REPAY': '去还款',
    'REPAYING': '去还款',
    'FINAL': '去提现',
    'LOAN': '去提现',
    'LOAN_PASSED': '开心收下',
    'DEFAULT': ''
  }
  let key = ''
  if (activeType === 'XIAOMEI_VIP' && couponChannel === 'BENEFIT' && couponType === 'CASH') {
    key = 'ACCEPT'
  } else if (Object.keys(map).includes(useAction)) {
    key = useAction
  } else {
    key = 'DEFAULT'
  }
  return map[key]
}


export default TicketsMaps